// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import Tooltip from 'rc-tooltip';
import type { Errors } from '../../types/errors';
import ErrorsNotification from '../../components/others/ErrorNotification';
import './ResourceGeneratorParams.css';

const entityLowerBound = 0;
const entityUpperBound = 5000;
const paxEntity = 'pax';
const daxEntity = 'dax';
const outOfBoundsErrorMessage = 'Range should be between 0 to 5000, inclusive';

type Props = {
  startGenerateResources: Function,
  fillCities: Function,
  handleCohortNameChange: Function,
  handleNumPaxChange: Function,
  handleNumDaxChange: Function,
  handleCityChange: Function,
  handleCohortTypeChange: Function,
  cohortType: string,
  errors: Errors,
  resetErrorState: Function,
};

export class ResourceGeneratorParams extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      disabledInputs: false,
      paxValOutOfBounds: false,
      daxValOutOfBounds: false,
    };
  }

  setEntityOutOfBounds = (entityType: string, trigger: boolean) => {
    if (entityType === paxEntity) {
      this.setState({
        paxValOutOfBounds: trigger,
      });
    } else if (entityType === daxEntity) {
      this.setState({
        daxValOutOfBounds: trigger,
      });
    }
  };

  checkPaxRange = (event: Object) => {
    event.persist();
    const paxVal = event.target.value;
    if (paxVal >= entityLowerBound && paxVal <= entityUpperBound) {
      this.setEntityOutOfBounds(paxEntity, false);
      this.props.handleNumPaxChange(paxVal);
    } else {
      this.setEntityOutOfBounds(paxEntity, true);
    }
  };

  checkDaxRange = (event: Object) => {
    event.persist();
    const daxVal = event.target.value;
    if (daxVal >= entityLowerBound && daxVal <= entityUpperBound) {
      this.setEntityOutOfBounds(daxEntity, false);
      this.props.handleNumDaxChange(daxVal);
    } else {
      this.setEntityOutOfBounds(daxEntity, true);
    }
  };

  entityInput = (handler: Function) =>
    <input
      className="input"
      type="number"
      onChange={handler}
      defaultValue={entityLowerBound}
      min={entityLowerBound}
      max={entityUpperBound}
    />;


  props: Props;

  render() {
    const { paxValOutOfBounds, daxValOutOfBounds } = this.state;
    return (
      <div className="resourceGeneratorParams">
        { !_.isEmpty(this.props.errors) &&
        <ErrorsNotification
          errors={this.props.errors}
          dismissible
          onClose={() => {
            this.props.resetErrorState('generateResources');
          }}
        />
        }
        <div className="field columns">
          <div className="label column is-half"> Name of Cohort </div>
          <div className="column is-fullwidth">
            <input
              className="input"
              type="text"
              placeholder="[optional]"
              onChange={this.props.handleCohortNameChange}
            />
          </div>
        </div>

        <div className="field columns">
          <div className="label column is-half"> Number of Passengers </div>
          <div className="column is-fullwidth">
            {this.entityInput(this.checkPaxRange)}
            {paxValOutOfBounds && <p className="help is-danger">{outOfBoundsErrorMessage}</p>}
          </div>
        </div>

        <div className="field columns">
          <div className="label column is-half"> Number of Drivers </div>
          <div className="column is-fullwidth">
            {this.entityInput(this.checkDaxRange)}
            {daxValOutOfBounds && <p className="help is-danger">{outOfBoundsErrorMessage}</p>}
          </div>
        </div>

        <div className="field columns">
          <div className="label column is-half" htmlFor="city">City</div>
          <div className="select column is-fullwidth">
            <select
              name="city"
              onChange={this.props.handleCityChange}
            >
              {this.props.fillCities()}
            </select>
          </div>
        </div>

        <div className="field columns">
          <div className="label column is-half" htmlFor="city">
            Cohort Type
            <Tooltip
              placement="right"
              trigger="hover"
              overlay={
                <span>
                  Select Persistent if you want to keep the cohort for a long term.<br />
                  Else, short-lived cohorts will be created with a duration of 1 hour from the time of creation.
                </span>
              }
            >
              <i className="fa fa-question-circle" />
            </Tooltip>
          </div>
          <div className="column is-fullwidth">
            <label className="radio" htmlFor="cohortType">
              <input
                type="radio"
                name="cohortType"
                value={0}
                checked={this.props.cohortType === '0'}
                onChange={this.props.handleCohortTypeChange}
              />
                Short-lived
            </label>
            <label className="radio right-radio" htmlFor="cohortType">
              <input
                type="radio"
                name="cohortType"
                value={1}
                checked={this.props.cohortType === '1'}
                onChange={this.props.handleCohortTypeChange}
              />
                Persistent
            </label>
            { this.props.cohortType === '1' ?
              <article className="message is-danger">
                <div className="message-body">
                  Select persistent if you want to keep the cohort for a long term
                </div>
              </article> : <noscript /> }
          </div>
        </div>

        <button
          className="button is-primary is-pulled-left"
          type="submit"
          onClick={this.props.startGenerateResources}
          disabled={paxValOutOfBounds || daxValOutOfBounds}
        >Generate</button>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./src/js/views/resource_generator/ResourceGeneratorParams.jsx
 **/